import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

const VariableMappings: { [key: string]: string } = {
  primary: '--color-primary',
  primaryBg: '--color-primary-bg',
  primaryBtnBg: '--color-primary-btn-bg',
  primaryBtnText: '--color-primary-btn-text',
  primaryExtraLight: '--color-primary-extra-light',
  primaryLight: '--color-primary-light',
  primaryMedium: '--color-primary-medium',
  primaryText: '--color-primary-text',

  secondaryBg: '--color-secondary-bg',
  secondaryBtnBg: '--color-secondary-btn-bg',
  secondaryBtnStroke: '--color-secondary-btn-stroke',
  secondaryBtnText: '--color-secondary-btn-text',
  secondaryText: '--color-secondary-text',

  tertiaryBtnBg: '--color-tertiary-btn-bg',
  tertiaryBtnText: '--color-tertiary-btn-text',
  tertiaryText: '--color-tertiary-text',

  strokeDefault: '--color-stroke-default',
  successDefault: '--color-success-default',
  warningDefault: '--color-warning-default',
  errorDefault: '--color-error-default',
};

const DefaultColors = {
  primary: '#3d38d0',
  primaryBg: '#ffffff',
  primaryBtnBg: '#3d38d0',
  primaryBtnText: '#ffffff',
  primaryExtraLight: '#f2f2ff',
  primaryLight: '#cdcaf6',
  primaryMedium: '#9e9bff',
  primaryText: '#000000',

  secondaryBg: '#f9f9f9',
  secondaryBtnBg: '#ffffff',
  secondaryBtnStroke: '#3d38d0',
  secondaryBtnText: '#3d38d0',
  secondaryText: '#545454',

  tertiaryBtnBg: '#f5f5f5',
  tertiaryBtnText: '#000000',
  tertiaryText: '#595959',

  strokeDefault: '#e6e6e6',
  successDefault: '#00bb77',
  warningDefault: '#b25e09',
  errorDefault: '#da2f2f',
};

@Injectable({
  providedIn: 'root',
})
export class ThemeColorsService {
  protected $document = inject(DOCUMENT);

  /**
   * Generate CSS variables string for inline styles or update CSS variables on :root.
   * @param colors - The color object with keys from cacheData.
   * @param operationKey - 'generate' to get CSS string, 'update' to update DOM variables.
   */
  public generateCssVariables(colors: { [colorMap: string]: string }): string {
    let cssVariablesFinal: string = ':root {';
    for (const [variableBackendKey, variableValue] of Object.entries(DefaultColors)) {
      const cssValue = colors[variableBackendKey] || variableValue;
      cssVariablesFinal += `${VariableMappings[variableBackendKey]}: ${cssValue};`;
    }

    cssVariablesFinal += '}';

    return cssVariablesFinal;
  }

  public injectToHtml(colors: { [key: string]: string } | null | undefined) {
    const style = this.$document.createElement('style');
    const cssColors = this.generateCssVariables(colors || DefaultColors);
    style.textContent = cssColors;
    this.$document.head.appendChild(style);
  }
}
